import TitleDashboard from "@components/general/Titles/TitleDashboard";
import CardBeneficios from "@components/usuario/CompraLicencia/CardBeneficios";
import DetalleCompra from "@components/usuario/CompraLicencia/DetalleCompra";
import GridPaquetes from "@components/usuario/CompraLicencia/GridPaquetes";
import AvisoPrivacidad from "@components/usuario/CompraLicencia/modals/avisoPrivacidad/AvisoPrivacidad";
import DirectorioTelefonico from "@components/usuario/CompraLicencia/modals/directorioTelefonico/DirectorioTelefonico";
import UserContext from "@context/User/UserContext";
import useWindowResize from "@customHooks/useWindowResize";
import { getPricesCompra, getPricesCompraExterna } from "@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos";
import Loader from "@helpers/loader/loader";
import { Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Container, Image, Navbar, Row } from "react-bootstrap";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ModalSweetAlert } from "@components/general/Alertas/Alertas";
import InfoKueski from "@helpers/kueski/modales/InfoKueski";

const CompraLicencia = () => {

	//TODO REALIZAR LAS SIGUIENTES VALIDACIONES:
	//*RECUPERAR PARAMETROS DE URL EN CASO DE SER UNA COMPRA SOLICITADA DESDE GLOBALCLICKLATAM.COM
	//*EN BASE A LOS PARAMETROS, SI EXISTEN HACER LAS VALIDACIONES PARA MOSTRAR LA COMPRA EN DOLARES

	const [precios, setPrecios] = useState(null);

	const [showLoader, setShowLoader] = useState(true);

	const [showModalAvisoPrivacidad, setShowModalAvisoPrivacidad] = useState(false);

	const [showModalDirectorioTelefonico, setShowModalDirectorioTelefonico] = useState(false);

	const [compraExterna, setCompraExterna] = useState(false);

	const [compraLectura, setCompraLectura] = useState(false);

	const [compraConvenio, setCompraConvenio] = useState(false);

	const darkTheme = createTheme({
		palette: {
			mode: "dark",
		},
	});

	const handleClickAvisoPrivacidad = () => {
		setShowModalAvisoPrivacidad(!showModalAvisoPrivacidad);
	};

	const handleClickDirectorioTelefonico = () => {
		setShowModalDirectorioTelefonico(!showModalDirectorioTelefonico);
	};

	const handleClickPreguntasFrecuentes = () => {
		let link = document.createElement("a");

		link.href = "https://globalclickmexico.com/faq/index.html";

		link.target = "_blank";

		link.dispatchEvent(new MouseEvent("click"));
	};

	const { contextValue, setContextValue } = useContext(UserContext);

	const consultarPreciosCompra = async () => {
		try {
			//Se reciben los datos para manejarlos en la vista pública
			const param = new URLSearchParams(window.location.search);

			const datosURL = param.get("new-license");
			//Transformamos el string del data en arreglo
   
			//Si la variable datosURL es diferente de null es una compra fuera de México
			
			let listaPrecios;

			if(datosURL === "true"){
				setCompraExterna(true);
				listaPrecios = await getPricesCompraExterna();
			}else{
				listaPrecios = await getPricesCompra();

			}

			//Cuando se asigna a este state se guarda en el contextValue para su uso posterior
			setPrecios(listaPrecios);
		} catch (error) {
			console.log("Error al consultar los precios de la compra: ", error);
		}
	};

		const handleKueskiInfo = ({ currentTarget }) => {
			ModalSweetAlert({
				title: "",
				html: <InfoKueski />,
				showConfirmButton: false,
				showCloseButton: true,
				width: "700px",
				height: "850px"
			});
		};

	const {
		size: { width },
	} = useWindowResize();

	useEffect(() => {

		if (precios !== null) {
			return setShowLoader(false);
		}

		consultarPreciosCompra();
	}, []);

	useEffect(() => {
		if (precios !== null) {
				//Se reciben los datos para manejarlos en la vista pública
		const param = new URLSearchParams(window.location.search);

		const lectura = param.get("lectura");
		let codigoConvenio = false;

		let codigoDescuento = "";

		if(lectura === 'true') {
			setCompraLectura(true);

			codigoDescuento = param.get("c");

			if(codigoDescuento !== null){
				codigoConvenio = true;
				setCompraConvenio(true);
			}
		}

		console.log('Se actualiza el context value');

			setContextValue({
				...contextValue,
				compra: {
					precios,
					compraLectura: lectura === "true" ? true : false,
					codigoConvenio: codigoConvenio ? codigoDescuento : ''
				},
			});

			setShowLoader(false);
		}
	}, [precios]);

	return (
		<>
			{showLoader ? (
				<Loader />
			) : (
				<ThemeProvider theme={darkTheme}>
					<CssBaseline />

					<div className="bg-main-container" style={{ overflow: "hidden", overflowY: "scroll" }}>
						<Navbar expand="lg" data-bs-theme="dark" bg="dark" className="bg-dark-custom">
							<Container fluid>
								<Navbar.Brand href="#">
									<div className="m-1">
										<img className="pointer" src={require(`@assets/images/logo-gc-horizontal.png`)} alt="Logo Global Click" style={{ width: `${width > 992 ? "10vw" : "20vw"}` }} />
										{compraConvenio && (
											<Image src={require("@assets/images/uvegActualizado.png")} style={{ width: "100px" }} />
										)}

										&nbsp;&nbsp;{!compraLectura ? "Compra de Licencia Plataforma Click+" : "Compra de curso de Lectura Inteligente"}
									</div>
								</Navbar.Brand>

								<div className="text-white d-flex justify-content-end">
									<Typography variant="overline" className="pointer px-3 hover-orange" onClick={handleClickAvisoPrivacidad}>
										Aviso de privacidad
									</Typography>

									<Typography variant="overline" className="pointer px-3 hover-orange" onClick={handleClickPreguntasFrecuentes}>
										Preguntas frecuentes
									</Typography>

									{/* <Typography variant="overline" className="pointer px-3 hover-orange" onClick={handleClickDirectorioTelefonico}>
										Directorio telefónico
									</Typography> */}
								</div>
							</Container>
						</Navbar>

						<Container className="py-30">
							<Row>
								<Col>
									<Container fluid className="bg-blue-gc card">
										<Row className="text-white">
											<Col>
												<Container fluid className="py-3">
													{!compraLectura ? (
														<>
															<TitleDashboard title="¿Qué cursos vas a adquirir?" />

															<GridPaquetes />

															<TitleDashboard title="¿Algo más?" />

															<CardBeneficios />
														</>
													): null}


													{(!compraExterna && !compraConvenio) ? (
														<>
															<TitleDashboard title="¡Compra ahora, paga después!" />
															<Row className="my-4">
																{/* <Col>
																	<Image src={require("@assets/images/Kueski/banner.jpg")} fluid />
																</Col> */}
																<Col>
																	<Card body className="bg-blue-gc text-white p-2" style={{border: "none"}}>
																		<h4>Realiza tu compra con <Image width="200" src={require("@assets/images/Kueski/logoKueski.png")} /> y aprovecha los beneficios que tiene para ti:</h4>
																	<ul>
																		<li>Paga hasta en 12 quincenas</li>
																		<li>Compra diferida sin tarjeta de crédito</li>
																		<li>Sin comisión por transacción</li>
																		<li>Pago <b>100% seguro</b></li>
																	</ul>

																		<Button onClick={handleKueskiInfo} className="btn btn-primary">¿Cómo funciona?</Button>
																	</Card>
																</Col>
															</Row>	
														</>
													): null}


													<TitleDashboard title="Detalle de Pago" />

													<DetalleCompra compraExterna={compraExterna}/>
												</Container>
											</Col>
										</Row>
									</Container>
								</Col>
							</Row>
						</Container>

						<Container fluid className="p-0">
							<Row>
								<Col>
									<Card>
										<Card.Body className="p-0">
											<Image fluid src={require("@assets/images/compra/compra-footer.jpg")} alt="Footer de Global Click México" className="w-100 h-100" />
										</Card.Body>
									</Card>
								</Col>
							</Row>
						</Container>

						<DirectorioTelefonico modalShow={showModalDirectorioTelefonico} setModalShow={setShowModalDirectorioTelefonico} />

						<AvisoPrivacidad modalShow={showModalAvisoPrivacidad} setModalShow={setShowModalAvisoPrivacidad} /> 
					</div>
				</ThemeProvider>
			)}
		</>
	);
};

export default CompraLicencia;
